import type { SorterResult } from 'antd/es/table/interface';

import { ListGroupsAdministrationOrderBy, ListUsersAdministrationOrderBy } from '@/modules/api/codegen';

import { UserAdministrationType } from '../constants';

export const mapAntdSorterToApiSort = <Sorter>(sorter: SorterResult<Sorter>, type: UserAdministrationType) => {
    const sortableColumns = type === UserAdministrationType.Users ? ListUsersAdministrationOrderBy : ListGroupsAdministrationOrderBy;

    if (
        'field' in sorter &&
        sorter.field &&
        sorter.order &&
        Object.values(sortableColumns).includes(sorter.field as keyof typeof sortableColumns)
    )
        return {
            orderBy: sorter.field as keyof typeof sortableColumns,
            orderDirection: sorter.order === 'ascend' ? 'asc' : 'desc',
        } as const;

    return undefined;
};
